function toggleFAQ(element) {
var answer = element.nextElementSibling;
var icon = element.querySelector('.faq-icon');
var faqItems = document.querySelectorAll('.faq-item');

// Close all other FAQ answers
faqItems.forEach(function(item) {
var itemAnswer = item.querySelector('.faq-answer');
var itemIcon = item.querySelector('.faq-icon');
if (itemAnswer !== answer) {
itemAnswer.style.display = 'none';
itemIcon.textContent = '+';
}
});

// Toggle current FAQ answer
if (answer.style.display === 'block') {
answer.style.display = 'none';
icon.textContent = '+';
} else {
answer.style.display = 'block';
icon.textContent = '-';
}
}

document.addEventListener("DOMContentLoaded", function() {

if (window.location.pathname === "/collections/all") {
window.location.href = "/pages/school";
}

document.querySelectorAll('a[href*="pages/school"], a[href*="pages/get-a-quotation-form"]').forEach(link => {
link.setAttribute('target', '_blank');
link.setAttribute('rel', 'noopener noreferrer');
});

if (document.body.classList.contains('saifee-high-school') || document.body.classList.contains('hasanat-high-school')) {
document.querySelector('.product-form__submit').addEventListener('click', function(event) {

const fields = document.querySelectorAll('.cstm_fields input');
let allFilled = true;
fields.forEach(function(field) {
if (field.value.trim() === '') {
allFilled = false;
}
});

// Show error message if any field is empty
if (!allFilled) {
event.preventDefault();
alert('All fields are required.');
} else {

}
});
}
});